import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

import { Tag } from "../definition";

@Component({
    selector: "app-dashboard-tags",
    template: `
        <div class="px-normal mt-3 mb-3">
            <h2 class="text-primary-500 font-bold"><ng-content></ng-content></h2>
        </div>

        <ng-container *ngIf="tags?.length; else empty">
            <div class="grid grid-cols-2 px-normal gap-3 mb-12">
                <div
                    class="rounded-lg shadow overflow-hidden relative ion-activatable cursor-pointer h-24 bg-white flex justify-center items-center"
                    [ngClass]="{ 'ring-2 ring-primary-400': tag.subscribed }"
                    *ngFor="let tag of tags"
                    [routerLink]="['/tags', tag.id]"
                >
                    <ng-container *ngIf="tag.id == 20; else default">
                        <div class="px-6 sm:px-8 md:px-12">
                            <img src="/assets/images/YESCON-logo.svg" />
                        </div>
                    </ng-container>

                    <ng-template #default>
                        <div
                            *ngIf="tag.svg"
                            class="text-primary-50 h-16 w-16 absolute top-2 left-2 fill-current stroke-current children:h-16 children:w-16"
                            [innerHTML]="tag.svg | safe: 'html'"
                        ></div>

                        <span class="font-extrabold text-base z-10 uppercase text-center block p-3">{{ tag.name }}</span>
                    </ng-template>

                    <ion-ripple-effect type="bounded"></ion-ripple-effect>
                </div>
            </div>
        </ng-container>

        <ng-template #empty>
            <app-view-empty
                [lead]="
                    'Du hast keine Themen abonniert. Abonniere Themen die Dich interessieren und Du erhälst hier die neusten Gruppen und Beiträge passend zum Thema' | translate
                "
                [icon]="['fal', 'tags']"
            >
            </app-view-empty>
        </ng-template>
        <div class="px-normal flex justify-center mt-3" *ngIf="showMore">
            <ion-button [routerLink]="['/tags']" fill="outline" shape="round">
                {{ "Alle Themen anzeigen" | translate }}
            </ion-button>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
            svg {
                height: 3.5em;
                width: 3.5em;
                color: red;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTagsComponent implements OnInit {
    @Input() tags: Tag[];
    @Input() showMore = true;
    constructor() {}

    ngOnInit(): void {}
}
